import React from 'react';
import { Link } from 'react-router-dom';

function CollectionListItem({ collection }) {
  return (<li>
    <Link to={`/collection/${collection.id}`}>{collection.name}</Link>
  </li>);
}

export default function CollectionList({ collections }) {
  if (collections) {
    const sorted = collections.sort((a, b) => {
      return a.name >= b.name ? -1 : 1;
    });
    return (<ul className='navigation-menu-list'>
      <li className='list-title'>Collections</li>
      {sorted.map((c) => <CollectionListItem key={c.id} collection={c} />)}
    </ul>);
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/components/CollectionList.js